module.exports = __webpack_public_path__ + "static/img/14001018.21a0824b.png";